module.exports = __webpack_public_path__ + "static/media/newUpload.ec7645f2.svg";